// react-redux-form setup for forms shared between the marketing site and the portal

const defaultReviewForm: Forms.ReviewForm = {
  customerInfo: {
    customerName: '',
    createdTimestamp: null,
  },
  overallFeedback: {
    reviewTitle: '',
    customerLocation: '',
    overallRating: null,
    overallComment: ''
  },
  travelLocalFeedback: {
    easeOfUseRating: null,
    improvementComment: '',
    whereNext: '',
    howLikelyToRecommend: null,
  },
  ltoFeedback: {
    ltoInteractionRating: null,
    valueRating: null,
    transportationRating: null,
    guideRating: null,
    ltoPositives: '',
    ltoImprovements: '',
    guideComment: '',
    locationAdvice: '',
    favoritePart: ''
  }
}

export const formModels = {
  newReview: defaultReviewForm,
  reviews: {}
};
